module.exports = __webpack_public_path__ + "static/media/Valeo-01.fb8213ec.jpg";